//
export var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["Purchase"] = "Purchase";
    TransactionTypeEnum["TopUp"] = "TopUp";
    TransactionTypeEnum["Redeem"] = "Redeem";
    TransactionTypeEnum["TransferIn"] = "Transfer In";
})(TransactionTypeEnum || (TransactionTypeEnum = {}));
export var TransactionTypeCodeEnum;
(function (TransactionTypeCodeEnum) {
    TransactionTypeCodeEnum[TransactionTypeCodeEnum["Purchase"] = 1] = "Purchase";
    TransactionTypeCodeEnum[TransactionTypeCodeEnum["TopUp"] = 2] = "TopUp";
    TransactionTypeCodeEnum[TransactionTypeCodeEnum["Redeem"] = 3] = "Redeem";
    TransactionTypeCodeEnum[TransactionTypeCodeEnum["TransferIn"] = 4] = "TransferIn";
})(TransactionTypeCodeEnum || (TransactionTypeCodeEnum = {}));
